var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0.00478125 12.4163 3.58369 15.9952 8 16ZM7.33334 4C7.33334 3.63181 7.63181 3.33334 8 3.33334C8.36819 3.33334 8.66666 3.63181 8.66666 4V9.33334C8.66666 9.70153 8.36819 10 8 10C7.63181 10 7.33334 9.70153 7.33334 9.33334V4ZM8 12C8.36819 12 8.66666 12.2985 8.66666 12.6667C8.66666 13.0348 8.36819 13.3333 8 13.3333C7.63181 13.3333 7.33334 13.0348 7.33334 12.6667C7.33334 12.2985 7.63181 12 8 12Z",
    fill: "#EF3E36"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_38542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorExclamationMark);
export default ForwardRef;